import { render } from "./config-loading.component.vue?vue&type=template&id=3840b13a&scoped=true"
const script = {}

import "./config-loading.component.vue?vue&type=style&index=0&id=3840b13a&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3840b13a"]])

export default __exports__